import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getAllPaymnets } from '../../../actions';
import browserHistory from '~/browserHistory';

/**
 * Fetches the office's payment methods once the route job has loaded, so the
 * confirm/decline flow can surface the payment-missing popup. Skips the fetch
 * when returning to the screen via the browser back button, and de-dupes per
 * office so a given office is only fetched once.
 */
export const usePaymentsForJob = ({
  job,
  jobId,
  hasLoadedJob,
  allCandidates,
  visibleCandidates,
}) => {
  const dispatch = useDispatch();
  const paymentsFetchOfficeIdRef = useRef(null);

  useEffect(() => {
    if (!hasLoadedJob || jobId !== job?.id || !job?.specialty) {
      return;
    }

    const backFromCandidateProfile =
      allCandidates?.length && visibleCandidates?.length && browserHistory.action === 'POP';

    if (backFromCandidateProfile) {
      return;
    }

    const officeId = job?.offer_owner?.id;
    if (!officeId || paymentsFetchOfficeIdRef.current === officeId) {
      return;
    }

    dispatch(getAllPaymnets(officeId));
    paymentsFetchOfficeIdRef.current = officeId;
  }, [
    allCandidates,
    dispatch,
    hasLoadedJob,
    job?.id,
    job?.offer_owner?.id,
    job?.specialty,
    jobId,
    visibleCandidates,
  ]);
};
